import { render, staticRenderFns } from "./courseZqjc.vue?vue&type=template&id=c9c4b0ba&scoped=true&"
import script from "./courseZqjc.vue?vue&type=script&lang=js&"
export * from "./courseZqjc.vue?vue&type=script&lang=js&"
import style0 from "./courseZqjc.vue?vue&type=style&index=0&id=c9c4b0ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c4b0ba",
  null
  
)

export default component.exports